module.exports = __webpack_public_path__ + "media/images/gallery/constellations/coma_berenices/com_gc-3b00842174a0151707148192030d15ab.gif";